import _ from 'lodash'
import { Record } from 'immutable'

import { SET_ACTIVE_MODULE } from '../../../../services/routing/constants'

const ModuleMenuRecord = Record({
    active: '',
})

export default (state = new ModuleMenuRecord(), action = {}) => {
    switch (action.type) {
        case SET_ACTIVE_MODULE: {
            const activeModule = _.get(action, 'data.module', '')

            return state.set('active', activeModule)
        }
        default:
            return state
    }
}
